import React from 'react';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import { trackClick } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';
import { useLocation } from 'react-router-dom';
import InfoModal from 'src/components/atomic/molecules/infoModal/InfoModal';

export interface TotalAverageInfoModalProps {
    anchorTitle: string;
    anchorTag: string;
}

export default function TotalAverageInfoModal({ anchorTitle, anchorTag }: TotalAverageInfoModalProps): JSX.Element {
    const { pathname } = useLocation();

    return (
        <InfoModal
            anchorTitle={anchorTitle}
            anchorTag={anchorTag}
            id="total-average-info-modal"
            title={LiteralsService.getLiteral('TotalAverageInfoModal.title')}
            body={
                <>
                    <Typography variant={TypographyVariants.BODY_BOLD} component="h2">
                        {LiteralsService.getLiteral('TotalAverageInfoModal.totalHeader')}
                    </Typography>
                    <Typography variant={TypographyVariants.BODY} component="p">
                        {LiteralsService.getLiteral('TotalAverageInfoModal.totalBody')}
                    </Typography>
                    <br />
                    <Typography variant={TypographyVariants.BODY_BOLD} component="h2">
                        {LiteralsService.getLiteral('TotalAverageInfoModal.averageHeader')}
                    </Typography>
                    <Typography variant={TypographyVariants.BODY} component="p">
                        {LiteralsService.getLiteral('TotalAverageInfoModal.averageBody')}
                    </Typography>
                </>
            }
            onCloseClick={() => trackClick(pathname, adobeTags.TotalAverageInfoModal.Close)}
        />
    );
}
